// src/EquipmentModal.js

import React, { useState, useEffect } from 'react';

// Stili interni per non creare un altro file CSS
const modalStyles = {
    position: 'fixed', zIndex: 2001, left: 0, top: 0, width: '100%', height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center'
};
const modalContentStyles = {
    backgroundColor: '#fefefe', padding: '25px', border: '1px solid #888',
    width: '90%', maxWidth: '500px', borderRadius: '8px',
    maxHeight: '90vh', overflowY: 'auto' // 🆕 scroll per form lungo
};
const specialtiesListStyles = {
    listStyle: 'none', padding: '10px', marginTop: '15px', maxHeight: '200px', overflowY: 'auto',
    border: '1px solid #eee', borderRadius: '5px'
};
const specialtyItemStyles = { padding: '8px 0', display: 'flex', alignItems: 'center', gap: '10px' };
const checkboxStyles = { width: '20px', height: '20px' };

// 🆕 Categorie diagnostiche predefinite
const CATEGORIE_DIAGNOSTICA = [
    { value: 'ecografia',       label: 'Ecografia' },
    { value: 'rx',              label: 'Radiografia (RX)' },
    { value: 'tac',             label: 'TAC / TC' },
    { value: 'risonanza',       label: 'Risonanza Magnetica (RM)' },
    { value: 'analisi_sangue',  label: 'Analisi del Sangue / Laboratorio' },
    { value: 'altro',           label: 'Altro' },
];

export function EquipmentModal({ equipmentData, allSpecialties, onSave, onClose }) {
    // ─── STATI ORIGINALI ───────────────────────────────────────────────────────
    const [name, setName] = useState('');
    const [selectedSpecialtyIds, setSelectedSpecialtyIds] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    // 🆕 STATI DIAGNOSTICA
    const [isDiagnostic, setIsDiagnostic] = useState(false);
    const [categorieEsami, setCategorieEsami] = useState([]);
    const [protocollo, setProtocollo] = useState('DICOM');
    const [produttore, setProduttore] = useState('');
    const [modello, setModello] = useState('');

    // STATI NOLEGGIO
    const [isRental, setIsRental] = useState(false);
    const [quantitaTotale, setQuantitaTotale] = useState(1);

    // ─── USEEFFECT ORIGINALE + 🆕 campi diagnostica ───────────────────────────
    useEffect(() => {
        if (equipmentData) {
            setName(equipmentData.name || '');
            setSelectedSpecialtyIds(equipmentData.specialtyIds || []);
            // 🆕
            setIsDiagnostic(equipmentData.isDiagnostic || false);
            setCategorieEsami(equipmentData.categorieEsami || []);
            setProtocollo(equipmentData.protocollo || 'DICOM');
            setIsRental(equipmentData.isRental || false);
            setQuantitaTotale(equipmentData.quantitaTotale || 1);
            setProduttore(equipmentData.produttore || '');
            setModello(equipmentData.modello || '');
        }
    }, [equipmentData]);

    // ─── HANDLER ORIGINALE ────────────────────────────────────────────────────
    const handleSpecialtyToggle = (specialtyId) => {
        setSelectedSpecialtyIds(prevIds =>
            prevIds.includes(specialtyId)
                ? prevIds.filter(id => id !== specialtyId)
                : [...prevIds, specialtyId]
        );
    };

    // 🆕 Toggle categoria diagnostica
    const handleCategoriaToggle = (value) => {
        setCategorieEsami(prev =>
            prev.includes(value)
                ? prev.filter(v => v !== value)
                : [...prev, value]
        );
    };

    // ─── HANDLESAVE ORIGINALE + 🆕 campi diagnostica ──────────────────────────
    const handleSave = () => {
        if (name.trim() === '') {
            alert('Il nome del macchinario è obbligatorio.');
            return;
        }
        // 🆕 Validazione: se diagnostico, almeno una categoria richiesta
        if (isDiagnostic && categorieEsami.length === 0) {
            alert('Seleziona almeno una categoria di esami per i macchinari diagnostici.');
            return;
        }

        const payload = {
            id: equipmentData?.id,
            name: name.trim(),
            specialtyIds: selectedSpecialtyIds,
            // 🆕 Campi diagnostica (sempre presenti nel payload)
            isDiagnostic: isDiagnostic,
            categorieEsami:  isDiagnostic ? categorieEsami : [],
            protocollo:      isDiagnostic ? protocollo : null,
            // 🎯 FIX: Salvataggio dati noleggio
            isRental:        isRental,
            quantitaTotale:  isRental ? parseInt(quantitaTotale) || 1 : 1,
            // Se è la prima volta che lo creiamo/abilitiamo, inUso parte da 0
            inUso:           equipmentData?.inUso || 0,
            produttore:      isDiagnostic ? produttore.trim() : null,
            modello:         isDiagnostic ? modello.trim() : null,
        };

        onSave(payload);
    };

    // ─── RENDER ───────────────────────────────────────────────────────────────
    const filteredSpecialties = [...allSpecialties]
        .sort((a, b) => a.name.localeCompare(b.name))
        .filter(spec => spec.name.toLowerCase().includes(searchTerm.toLowerCase()));

    return (
        <div style={modalStyles} onClick={onClose}>
            <div style={modalContentStyles} onClick={e => e.stopPropagation()}>
                <h3>{equipmentData ? 'Modifica Macchinario' : 'Nuovo Macchinario'}</h3>

                <div style={{ textAlign: 'left', marginTop: '15px' }}>

                    {/* ── SEZIONE ORIGINALE: Nome ── */}
                    <label htmlFor="equip-name">Nome Macchinario</label>
                    <input
                        id="equip-name" type="text" value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Es. Ecografo Multidisciplinare"
                        style={{ width: '100%', padding: '10px', fontSize: '1rem', boxSizing: 'border-box' }}
                    />

                    {/* ── SEZIONE ORIGINALE: Specialistiche ── */}
                    <label style={{ marginTop: '15px', display: 'block', fontWeight: 'bold' }}>
                        Associa a Specialistiche:
                    </label>
                    <input
                        type="text"
                        placeholder="Cerca specialistiche..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ width: '100%', padding: '10px', fontSize: '1rem', boxSizing: 'border-box', margin: '10px 0' }}
                    />
                    <ul style={specialtiesListStyles}>
                        {filteredSpecialties.map(spec => (
                            <li key={spec.id} style={specialtyItemStyles}>
                                <input
                                    type="checkbox"
                                    id={`spec-${spec.id}`}
                                    checked={selectedSpecialtyIds.includes(spec.id)}
                                    onChange={() => handleSpecialtyToggle(spec.id)}
                                    style={checkboxStyles}
                                />
                                <label htmlFor={`spec-${spec.id}`}>{spec.name}</label>
                            </li>
                        ))}
                    </ul>

                    {/* 🆕 ── SEZIONE DIAGNOSTICA ── */}
                    <div style={{
                        marginTop: '20px',
                        borderTop: '2px dashed #e2e8f0',
                        paddingTop: '15px'
                    }}>
                        {/* Toggle principale */}
                        <label style={{
                            display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer',
                            padding: '12px', borderRadius: '8px',
                            backgroundColor: isDiagnostic ? '#eff6ff' : '#f8f9fa',
                            border: isDiagnostic ? '1px solid #bfdbfe' : '1px solid #e5e7eb',
                            transition: 'all 0.2s'
                        }}>
                            <input
                                type="checkbox"
                                checked={isDiagnostic}
                                onChange={e => setIsDiagnostic(e.target.checked)}
                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                            />
                            <div>
                                <div style={{ fontWeight: 'bold', color: isDiagnostic ? '#1d4ed8' : '#374151' }}>
                                    🔬 Macchinario Diagnostico per Immagini
                                </div>
                                <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '2px' }}>
                                    Abilita la gestione di esami diagnostici, refertazione e portale paziente
                                </div>
                            </div>
                        </label>

                        {/* Sezione espandibile — visibile solo se isDiagnostic */}
                        {isDiagnostic && (
                            <div style={{
                                marginTop: '15px',
                                padding: '15px',
                                backgroundColor: '#f8faff',
                                border: '1px solid #dbeafe',
                                borderRadius: '8px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '15px'
                            }}>

                                {/* Categorie esami */}
                                <div>
                                    <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '8px', color: '#1e40af' }}>
                                        Categorie di Esami Prodotti *
                                    </label>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                        {CATEGORIE_DIAGNOSTICA.map(cat => (
                                            <label
                                                key={cat.value}
                                                style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', padding: '6px 8px', borderRadius: '5px', backgroundColor: categorieEsami.includes(cat.value) ? '#dbeafe' : 'transparent' }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={categorieEsami.includes(cat.value)}
                                                    onChange={() => handleCategoriaToggle(cat.value)}
                                                    style={{ width: '16px', height: '16px' }}
                                                />
                                                <span style={{ fontSize: '0.9rem' }}>{cat.label}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                {/* Protocollo */}
                                <div>
                                    <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px', color: '#1e40af' }}>
                                        Protocollo di Comunicazione
                                    </label>
                                    <select
                                        value={protocollo}
                                        onChange={e => setProtocollo(e.target.value)}
                                        style={{ width: '100%', padding: '9px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '0.95rem' }}
                                    >
                                        <option value="DICOM">DICOM (Immagini — Ecografi, TAC, RX, RM)</option>
                                        <option value="HL7">HL7 (Dati Testuali — Analisi, Uroflussimetri)</option>
                                        <option value="manuale">Manuale (Upload diretto file)</option>
                                    </select>
                                </div>

                                {/* Produttore e Modello */}
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    <div style={{ flex: 1 }}>
                                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px', color: '#1e40af' }}>
                                            Produttore
                                        </label>
                                        <input
                                            type="text"
                                            value={produttore}
                                            onChange={e => setProduttore(e.target.value)}
                                            placeholder="Es. Samsung, Philips..."
                                            style={{ width: '100%', padding: '9px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '0.95rem', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px', color: '#1e40af' }}>
                                            Modello
                                        </label>
                                        <input
                                            type="text"
                                            value={modello}
                                            onChange={e => setModello(e.target.value)}
                                            placeholder="Es. WS80A, Lumify..."
                                            style={{ width: '100%', padding: '9px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '0.95rem', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                            </div>
                        )}
                    </div>
                    {/* 🆕 ── FINE SEZIONE DIAGNOSTICA ── */}

                    {/* 🎯 FIX: SEZIONE NOLEGGIO */}
                    <div style={{ marginTop: '20px', borderTop: '2px dashed #e2e8f0', paddingTop: '15px' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer', padding: '12px', borderRadius: '8px', backgroundColor: isRental ? '#f0fdf4' : '#f8f9fa', border: isRental ? '1px solid #bbf7d0' : '1px solid #e5e7eb', transition: 'all 0.2s' }}>
                            <input type="checkbox" checked={isRental} onChange={e => setIsRental(e.target.checked)} style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
                            <div>
                                <div style={{ fontWeight: 'bold', color: isRental ? '#166534' : '#374151' }}>📦 Macchinario a Noleggio</div>
                                <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '2px' }}>Abilita per permettere di affittarlo ai pazienti tramite i pacchetti.</div>
                            </div>
                        </label>

                        {isRental && (
                            <div style={{ marginTop: '15px', padding: '15px', backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '8px', color: '#334155' }}>
                                    Quante unità hai in clinica di questo macchinario?
                                </label>
                                <input
                                    type="number" min="1"
                                    value={quantitaTotale}
                                    onChange={e => setQuantitaTotale(e.target.value)}
                                    style={{ width: '100px', padding: '9px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '1rem', boxSizing: 'border-box' }}
                                />
                                {equipmentData?.inUso > 0 && (
                                    <div style={{ fontSize: '0.8rem', color: '#d97706', marginTop: '8px', fontWeight: 'bold' }}>
                                        Attenzione: {equipmentData.inUso} unità sono attualmente fuori a noleggio. Non abbassare il totale sotto questo numero.
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    {/* 🎯 ── FINE SEZIONE NOLEGGIO ── */}

                </div>

                <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                    <button onClick={handleSave} className="modal-button confirm-button">
                        Salva
                    </button>
                    <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
                </div>
            </div>
        </div>
    );
}